import QuickReview from "./QuickReview";

export default QuickReview;



// WEBPACK FOOTER //
// ./src/components/QuickReview/index.js